import { Components, Theme } from '@mui/material';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    outlined: ({ ownerState }) => ({
      transform: 'translate(14px, 10px) scale(1)',
      ...(ownerState.shrink && {
        transform: 'translate(14px, -9px) scale(0.75)',
      }),
    }),
  },
};
